import { render, staticRenderFns } from "./auth-header.vue?vue&type=template&id=6eba7ff2&scoped=true&lang=pug&"
import script from "./auth-header.vue?vue&type=script&lang=js&"
export * from "./auth-header.vue?vue&type=script&lang=js&"
import style0 from "./auth-header.vue?vue&type=style&index=0&id=6eba7ff2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eba7ff2",
  null
  
)

export default component.exports